import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

const FRONT_BUMPER_LABEL = 'Front Bumper';

interface FrontBumperProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontBumper(props: FrontBumperProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label={FRONT_BUMPER_LABEL}
      width={196}
      height={502}
      viewBox="0 0 196 502"
      position={{top: 0, left: 0}}
    >
      <path
        d="M11 264.999V251V237C10.9999 230.189 16 219 16 219C24.2294 203.97 18.2683 148.116 31 119C43.2801 90.9167 104.115 35.8783 121 32.0002C121 32.0002 163 1.00247 195 1.00247V1.00018L171 1.00221L170.769 1.0022C151.456 1.00169 90.9683 1.0001 60 32C17.8742 74.1686 1 164.823 1 209V251V293C1 337.177 17.8742 427.831 60 470C90.9684 501 151.457 500.998 170.769 500.998H171L195 500.997C163 500.997 121 469.999 121 469.999C104.115 466.121 43.2801 411.083 31 382.999C18.2683 353.883 24.2294 298.03 16 282.999C16 282.999 10.9999 271.81 11 264.999Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M11 264.999V251V237C10.9999 230.189 16 219 16 219C24.2294 203.97 18.2683 148.116 31 119C43.2801 90.9167 104.115 35.8783 121 32.0002C121 32.0002 163 1.00247 195 1.00247V1.00018L171 1.00221L170.769 1.0022C151.456 1.00169 90.9683 1.0001 60 32C17.8742 74.1686 1 164.823 1 209V251V293C1 337.177 17.8742 427.831 60 470C90.9684 501 151.457 500.998 170.769 500.998H171L195 500.997C163 500.997 121 469.999 121 469.999C104.115 466.121 43.2801 411.083 31 382.999C18.2683 353.883 24.2294 298.03 16 282.999C16 282.999 10.9999 271.81 11 264.999Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
